import {
    ScheduleSourceType,
    ScheduleType,
} from "@common/types/domains/accounting/schedule";
import type { ApplySourceType } from "./ScheduleApplyFields";

export type ApplySourceDestination = "transactions" | "invoices" | "bills";

export type SourceOption =
    | {
          action: "navigate";
          key: ApplySourceDestination;
          title: string;
          description: string;
      }
    | {
          action: "select";
          key: "manual";
          title: string;
          description: string;
          sourceType: ApplySourceType;
      };

const TRANSACTIONS_SOURCE_OPTION: SourceOption = {
    action: "navigate",
    key: "transactions",
    title: "Add transactions",
    description: "Link one or more bank transactions to this schedule.",
};

const INVOICES_SOURCE_OPTION: SourceOption = {
    action: "navigate",
    key: "invoices",
    title: "Add invoices",
    description: "Link one or more invoices to this schedule.",
};

const BILLS_SOURCE_OPTION: SourceOption = {
    action: "navigate",
    key: "bills",
    title: "Add bills",
    description: "Link one or more bills to this schedule.",
};

export const EXTERNAL_SOURCE_OPTIONS: SourceOption[] = [
    {
        action: "select",
        key: "manual",
        title: "Add manually",
        description:
            "No data in Kick to link? Enter a manual source to trigger a schedule (recommended for migrated entities).",
        sourceType: ScheduleSourceType.manual,
    },
];

/**
 * Invoices carry revenue and bills expense, so each policy offers the
 * document its kind can apply to. Bills show only while the bills grid has
 * its Schedule column (`schedules-expenses`).
 */
export function getInKickSourceOptions(options: {
    scheduleType: ScheduleType | null;
    isBillsSourceEnabled: boolean;
}): SourceOption[] {
    if (options.scheduleType !== ScheduleType.expense) {
        return [TRANSACTIONS_SOURCE_OPTION, INVOICES_SOURCE_OPTION];
    }
    return options.isBillsSourceEnabled
        ? [TRANSACTIONS_SOURCE_OPTION, BILLS_SOURCE_OPTION]
        : [TRANSACTIONS_SOURCE_OPTION];
}
